import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'InnerFooter',
  templateUrl: './inner-footer.component.html',
  styleUrls: ['./inner-footer.component.scss']
})
export class InnerFooterComponent {

}
